export default "/images/vendor/flag-icon-css/flags/4x3/in.svg?1434165acf97a8c1a31a1d7702d03ca5";